import { render, staticRenderFns } from "./exchange-cash.vue?vue&type=template&id=6b5b92f0&scoped=true&"
import script from "./exchange-cash.js?vue&type=script&lang=js&"
export * from "./exchange-cash.js?vue&type=script&lang=js&"
import style0 from "./exchange-cash.scss?vue&type=style&index=0&id=6b5b92f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b92f0",
  null
  
)

export default component.exports